import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useEffect } from 'react';
import { ForgotPassword as ForgotPasswordWidget } from '../../../components/Authentication/widgets/ForgotPassword.js';
import { MigrateAccount as MigrateAccountWidget } from '../../../components/Authentication/widgets/MigrateAccount.js';
import { Registration as RegistrationWidget } from '../../../components/Authentication/widgets/Registration.js';
import { SignIn as SignInWidget } from '../../../components/Authentication/widgets/SignIn.js';
import { useAuthentication } from '../../../hooks/index.js';
export const Authentication = ({
  onSuccessSignIn
}) => {
  const {
    refreshToken,
    isLoggedIn
  } = useAuthentication();
  const refreshCallback = useCallback(() => {
    refreshToken();
  }, [refreshToken]);
  useEffect(() => {
    const interval = setInterval(() => {
      if (isLoggedIn) {
        refreshCallback();
      } else {
        clearInterval(interval);
      }
    }, 300_000);
    return () => clearInterval(interval);
  }, [isLoggedIn, refreshCallback]);
  return _jsxs(_Fragment, {
    children: [_jsx(SignInWidget, {
      onSuccess: onSuccessSignIn
    }), _jsx(RegistrationWidget, {}), _jsx(ForgotPasswordWidget, {}), _jsx(MigrateAccountWidget, {})]
  });
};